import theme from '../../theme/theme';

const {
  colors: {
    subtitle,
    list_number,
    mp_flag,
    remove_icon,
    divider,
    black_text,
    list_opacity,
    stars_unrated,
    stars_rated,
  },
} = theme;

const styles = {
  divider: {
    color: divider,
    borderRadius: 0,
    height: '0.063em',
  },

  scroll__wheel: {
    height: '26.05em',
    overflow: 'auto',
    position: 'relative',
    flex: 1,
  },

  menuItem__container: {
    height: 'auto',
    padding: 0,
    paddingBottom: '.8em',
    paddingTop: '.8em',
  },

  list__container: {
    display: 'flex',
    width: '100%',
    alignItems: 'baseline',
  },

  index__container: {
    display: 'flex',
    flex: 1,
  },

  left__alphabet: {
    color: list_number,
    fontFamily: 'semibold',
    fontSize: '1.125em',
    height: '1.625em',
    letterSpacing: '-0.031em',
    paddingLeft: '1.438em',
    paddingRight: '1.313em',
  },

  center__container: {
    wordBreak: 'break-word',
    whiteSpace: 'normal',
    width: '75%',
  },

  title__text: {
    alignItems: 'center',
    color: black_text,
    fontSize: '1.5em',
    fontWeight: 'normal',
    letterSpacing: '-0.031em',
  },

  arrow__right: {
    position: 'absolute',
    right: 0,
    paddingRight: '1.375em',
    marginTop: '.3em',
  },

  display__flex: {
    display: 'flex',
  },

  subtitle: {
    color: subtitle,
    fontSize: '1.125em',
    fontWeight: 'normal',
    height: '1.625em',
    letterSpacing: '-0.031em',
  },

  star__rated: {
    color: stars_rated,
    fontSize: '1.125em',
    padding: 0,
    marginTop: '.3em',
  },

  star__unrated: {
    color: stars_unrated,
    fontSize: '1.2em',
    padding: 0,
  },

  mp: {
    color: mp_flag,
    fontSize: '1em',
    paddingLeft: '.4em',
    position: 'absolute',
    paddingTop: '.25em',
  },

  dot: {
    paddingLeft: '0.375em',
    paddingRight: '0.375em',
    color: subtitle,
    fontSize: '1.125em',
    fontWeight: 'normal',
  },

  close__hour: {
    color: subtitle,
    fontSize: '1.125em',
    fontWeight: 'normal',
    height: '1.625em',
    letterSpacing: '-0.031em',
  },

  remove_icon: {
    right: '8%',
    fontSize: '1.750em',
    color: remove_icon,
  },

  overlay: {
    position: 'fixed',
    left: 0,
    bottom: 0,
    height: '2em',
    width: '100%',
    background: list_opacity,
  },
};

export default styles;
